import React, { Component } from 'react'
import {
  MessageComponentProps,
  MessageBubble,
  MessageBubbleText,
  FirebaseMessage
} from '@deal/chat-firebase'
import { Image } from '@deal/components'
import { Link } from 'react-router-dom'
import numeral from 'numeral'
import {
  ExpertCuratedOrderRichCardComponent,
  ExpertCuratedOrderLineItemFragment,
  MessageRichCardType,
  ExpertCuratedVariationOptionFragment
} from '#src/generated/graphql'
import styles from './styles.css'

export default class ConsumerNotifyExpertCuratedOrder extends Component<MessageComponentProps> {
  public static handlesMessage(message: FirebaseMessage) {
    return (
      message.parts[0].type == 'TEMPLATE_CAROUSEL' &&
      (message.parts[0].body.richCardType ===
        MessageRichCardType.CONSUMER_INTERESTED_IN_CURATED_ORDER ||
        message.parts[0].body.type === 'consumer-notify-expert-curated-order') &&
      message.parts[0].body.queryVariables &&
      message.parts[0].body.queryVariables.expertCuratedOrderId
    )
  }

  public render() {
    const orderId = this.props.message.parts[0].body.queryVariables.expertCuratedOrderId

    return (
      <ExpertCuratedOrderRichCardComponent variables={{ id: orderId }}>
        {({ data, loading }) => {
          if (loading) {
            return (
              <MessageBubbleText message={this.props.message} myself={this.props.myself}>
                Loading...
              </MessageBubbleText>
            )
          } else if (data && data.expertCuratedOrder) {
            const { order, variationOptions, curatedFor: { firstName } } = data.expertCuratedOrder

            const { title, primaryImage, lineItems, totalCostBeforeTax } = order

            const selectedVariaiton = variationOptions.find(option => option.selected)

            return (
              <MessageBubble message={this.props.message}>
                <div className={styles.hero}>
                  {primaryImage && (
                    <Image
                      src={primaryImage.url}
                      width={384}
                      height={134}
                      imgixParams={{ fit: 'crop' }}
                      className={styles.heroImage}
                      htmlAttributes={{
                        alt: `${title} curated for ${firstName}`
                      }}
                    />
                  )}
                </div>
                <div className={styles.content}>
                  <div className={styles.user}>{firstName} has requested this charter:</div>

                  {title && <div className={styles.sellableTitle}>{title}</div>}

                  <div>
                    {lineItems.map(orderLineItem => (
                      <SingleLineItem
                        key={orderLineItem.id}
                        lineItem={orderLineItem}
                        selectedVariation={selectedVariaiton}
                      />
                    ))}

                    <div className={styles.lineItem}>
                      <div className={styles.lineItemTitle}>
                        <strong>Total</strong>
                      </div>
                      <div className={styles.lineItemPrice}>
                        <strong>{numeral(totalCostBeforeTax.amount).format('$0,0.00')}</strong>
                      </div>
                    </div>
                  </div>
                </div>
                <Link to={`/curations/experiences/details/${orderId}`} className={styles.cta}>
                  View Charter
                </Link>
              </MessageBubble>
            )
          } else {
            return (
              <MessageBubbleText message={this.props.message} myself={this.props.myself}>
                Error loading messages!
              </MessageBubbleText>
            )
          }
        }}
      </ExpertCuratedOrderRichCardComponent>
    )
  }
}

interface LineItemProps {
  lineItem: ExpertCuratedOrderLineItemFragment
  selectedVariation?: ExpertCuratedVariationOptionFragment
}

const SingleLineItem: React.SFC<LineItemProps> = ({ lineItem, selectedVariation }) => {
  if (lineItem.isGroup) {
    return null
  }

  const duration =
    selectedVariation &&
    selectedVariation.sellable.variants[0] &&
    selectedVariation.sellable.variants[0].displayValueHtml

  return (
    <div key={lineItem.id}>
      <div className={styles.lineItem}>
        <span className={styles.lineItemTitle}>
          {lineItem.title}
          {lineItem.source.__typename === 'OrderLineItemBasePriceSource' &&
            duration &&
            `(${duration})`}
        </span>
        <span className={styles.lineItemPrice}>
          {lineItem.unitPrice ? (
            numeral(lineItem.unitPrice.amount).format('$0,0.00')
          ) : (
            <span className={styles.free}>Free</span>
          )}
          {lineItem.quantity > 1 && `x ${lineItem.quantity}`}
        </span>
      </div>
    </div>
  )

  return null
}
